import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { TeleconsultaEspecialidade } from "app/models/teleconsulta-especialidade";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class TeleconsultaEspecialidadeService {
   private API_URL: string = environment.apiUrl;

   constructor(
      private http: Http,
   ) { }

   obterEspecialidades(): Observable<TeleconsultaEspecialidade[]> {
      return this.http.get(this.API_URL + 'TeleconsultaEspecialidades')
         .map(
            response => response.json(),
            error => error.json()
         );
   }
}


// WEBPACK FOOTER //
// ./src/app/app-services/teleconsulta-especialidades.service.ts